<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import Change from "./question.vue";
export default {
  extends: baseEdit,
  components: {
    change: Change,
  },
  data() {
    return {
      mname: 'work',
      key: 'id',
      ll: [],
      url: {
      },
      items: [
        {
          label: "科室",
          name: "deskId",
          value: "",
          type: "selectDesk",
          width: "400px",
          dropList: [],
          rules: [
            {
              required: true,
              message: "科室不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
          selected: 0,
          onChange: this.onChangefacility,
        },
        {
          label: "科室信息",
          name: "deskinfo",
          value: "",
          type: "input",
          width: "400px",
          disabled: "true",
        },
        {
          label: "资产",
          name: "facilityNo",
          value: "",
          type: "select",
          dropList: [],
          width: "480px",
          rules: [{ required: true, trigger: "blur" }],
          onChange: this.onChangeFacilityType,
        },
        {
          label: "故障类型",
          name: "typeParentId",
          name2: "typeId",
          key: "name",
          value: "",
          value2: "",
          type: "selectTypeChild",
          width: "200px",
          dropList: [],
          dropList2: [],

          // desc: "如确认非硬件问题请选择关联性报修！",
          rules: [
            {
              required: true,
              message: "故障类型不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
          onChange: this.onChangetypes,
        },
        {
          label: "问题描述",
          name: "descr",
          value: "",
          dropList: [],
          type: "pullinput",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
          onFocus: this.onTextFocus,
          onChange: this.onTextChange,
          onExtClick: this.onTextExtClick,
        },
        {
          label: "派单类型",
          name: "sendType",
          value: 2,
          type: "select",
          width: "240px",
          dropList: [
            { value: 1, name: "手动派单" },
            { value: 2, name: "自动派单" },
          ],
          rules: [{ required: true, trigger: "blur", type: "number" }],
          onChange: this.onChangeType,
        },
        {
          label: "",
          name: "maintainerId",
          value: "",
          type: "select",
          width: "240px",
          dropList: [],
        },
        {
          label: "维修时间",
          name: "maintainType",
          value: 2,
          type: "select",
          width: "240px",
          dropList: [
            { value: 1, name: "预约维修" },
            { value: 2, name: "立即维修" },
          ],
          rules: [{ required: true, trigger: "blur", type: "number" }],
          onChange: this.ontermtype,
        },
        {label: '', name: 'makeTime', value: '', type: 'datetime'},
      ],
      forms: {
        repairSource: 1,
        descr: '',
        maintainerContent: '',
        teackRemark: '',
        typeParentId: 0,
        deskinfo: null,
        msgkv: '',
        repairPhone: '',
      },
    };
  },
  computed: {
    extRender() {
      return ["change"];
    },
  },
  created() {
    this.loadLevelData()
    // this.loaduserData();
    this.loadworkData();
    this.loadcommonData();
    let query = this.$route.query;
    if (query.phone) {
      this.forms.repairPhone = query.phone
      this.loadDeskData(this.forms.repairPhone)

    }
    if (query.kv) {
      this.kv = query.kv;
    }
    if (query.cv) {
      this.cv = query.cv;
    }
    if (query.msgkv) {
      this.msgkv = query.msgkv;
    }
  },
  mounted() {
    this.onChangeType(2);
    this.ontermtype(2);
    this.items[this.getItemIndex("sendType")].value = 2;
    if (this.kv === "flash") {
      this.items[this.getItemIndex("facilityNo")].type = "kong";
    }
    if (this.cv === "flash") {
      this.items[this.getItemIndex("facilityNo")].type = "kong";
    }

  },
  methods: {
    onChangeType(val) {
      if (val == 1) {
        this.items[this.getItemIndex("maintainerId")].type = "select";
      }
      if (val == 2) {
        this.items[this.getItemIndex("maintainerId")].type = "kong";
      }
    },
    ontermtype(val) {
      if (val == 1) {
        this.items[this.getItemIndex("makeTime")].type = "datetime";
      }
      if (val == 2) {
        this.items[this.getItemIndex("makeTime")].type = "kong";
      }
    },
    async handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms
      if (q.typeId === undefined || q.typeId === "" || q.typeId === null){
        q.typeId = q.typeParentId
      }
      if (this.kv === "flash" || this.cv === "flash") {
        this.forms.isFastOrder = 1;
      } else {
        this.forms.isFastOrder = 0;
      }
      q.repairSource = 3
      this.$refs.form.validate(async(valid) => {
        if (valid && this.msgkv == "add") {
          this.forms.callId = null;
          this.sloading = true;
          let res = await $utils.api.load(`/customer/customer/workOrder`, q, this.action == "edit" ? "PUT" : "POST")
            try {


              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            } catch(e){
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            }
        }
        if (valid && this.msgkv == "flashadd") {
          this.forms.callId = null;
          this.sloading = true;
         let res = await $utils.api.load(`/customer/customer/workOrder`, q, this.action == "edit" ? "PUT" : "POST")
            try{
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            }catch(e){
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            }
        }
      });
    },
    onChangefacility(deskId) {
      this.loadfacilityData(deskId);
      // this.forms.facilityNum= ''
      // // this.forms.unit_id= ''
    },
    onChangeFacilityType(facilityNo) {
      this.loadfacilitytypeData(facilityNo);
    },
    onChangetypes(typeParentId) {
      if (typeParentId != null) {
        this.loaduserData(typeParentId);
      }
    },
    onTextChange(val) {
    },
    onTextFocus() {
    },
    onTextExtClick(v) {
      let _this = this
      if (v.name === 'descr') {
        this.$refs.change[0].loadData(1)
        // 按钮显示常用语
        if (this.$refs.change && this.$refs.change[0]) {
          this.$refs.change[0].open()
          this.$refs.change[0].getText = (val) => {
            _this.forms.descr += val + ''
          }
        }
      } else if (v.name === 'maintainerContent') {
        this.$refs.change[0].loadData(2)
        // 按钮显示常用语
        if (this.$refs.change && this.$refs.change[0]) {
          this.$refs.change[0].open()
          this.$refs.change[0].getText2 = (val) => {
            _this.forms.maintainerContent += val + ''
          }
        }
      } else if (v.name === 'teackRemark') {
        this.$refs.change[0].loadData(3)
        // 按钮显示常用语
        if (this.$refs.change && this.$refs.change[0]) {
          this.$refs.change[0].open()
          this.$refs.change[0].getText3 = (val) => {
            _this.forms.teackRemark += val + ''
          }
        }
      }
    },
    handleSearch(descr) {
      let ll = this.ll;
      let newll = [];
      for (let index = 0; index < ll.length; index++) {
        let obj = ll[index] || {};
        let descrOld = obj.descr;
        if (descrOld.indexOf(descr) != -1) {
          newll.push(obj);
        }
      }
      let dropListarr = [];
      for (let index = 0; index < newll.length; index++) {
        const element = newll[index];
        let xx = {};
        xx.value = element.descr;
        xx.name = element.descr;
        xx.children = element.children || [];
        dropListarr.push(xx);
      }
      for (let index = 0; index < this.items.length; index++) {
        const element = this.items[index];
        if (element && element.name == "descr") {
          this.items[index]["dropList"] = dropListarr;
          // this.items[index]["dropList"] = (
          //   this.items[index]["dropList"] || []
          // ).concat(dropList);
        }
      }
      // return a;
    },
    loadcommonData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/customer/customer/common/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          this.ll = ll;
        }
      });
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load(`/customer/customer/desk/list`, q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.deskName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "deskId") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    loadfacilityData(deskId) {
      let that = this;
      if (deskId) {
        let id = deskId
        // 通过pk查询字典数据
        $utils.api.load(`/customer/customer/desk/${id}`).then((res) => {
          if (res && res.data) {
            let workInfotemp = "";
            if (res.data.principal !== null && res.data.principal !== undefined) {
              workInfotemp = res.data.principal;
            }
            // console.log(666,workInfotemp)
            if (res.data.phone !== null && res.data.phone !== undefined) {
              workInfotemp = workInfotemp +  "/" + res.data.phone;
            }
            // console.log(777,workInfotemp)
            if (res.data.address !== null && res.data.address !== "") {
              workInfotemp = workInfotemp +  "/" +res.data.address;
            }
            // console.log(888,workInfotemp)
            that.forms.deskinfo = workInfotemp;
          }
        });
      } else {
        that.forms.deskinfo = "";
      }

      // 通过pk查询字典数据
      let q = {};
      q.state = 2;
      q.deskId = deskId;
      $utils.api.load("/customer/customer/facility/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.facilityNum;
            xx.name =
              element.facilityNum +
              "_" +
              element.facilityName +
              "_" +
              element.installationSite;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "facilityNo") {
              this.items[index]["dropList"] = dropList;
            }
          }
        }
      });
    },
    async loadfacilitytypeData(facilityNo) {
      if (facilityNo) {
        let q = {};
        q.facilityNum = facilityNo;
        let res = $utils.api.load("/customer/customer/workType/scanList", q)
          if (res && res.rows) {
            let ll = res.rows;
            let dropList = [];
            for (let index = 0; index < ll.length; index++) {
              const element = ll[index];
              let xx = {};
              xx.value = element.id;
              xx.name = element.name;
              xx.children = element.children || [];
              dropList.push(xx);
            }
            for (let index = 0; index < this.items.length; index++) {
              const element = this.items[index];
              if (element && element.name == "typeParentId") {
                this.items[index]["dropList"] = dropList;
              }
            }
            this.forms.typeParentId = ll[0].id;
            this.onChangetypes(this.forms.typeParentId);
          }
      }
    },
    //选择故障类型下拉框
    async loadworkData() {
      // 通过pk查询字典数据
      let q = {};
      let res = await $utils.api.load("/customer/customer/workType/parentType", q,'get')
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "typeParentId") {
              this.items[index]["dropList"] = dropList;
            }
          }
        }
      },
    //选择故障类型下拉框
    async loadChildData(typeParentId) {
      // 通过pk查询字典数据
      let workType = {
        parentId: typeParentId
      }
      let res = await $utils.api.load('/customer/customer/workType/childType',workType,'get')
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value2 = element.id;
            xx.name2 = element.name;
            dropList.push(xx);
          }

          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name2 == "typeId") {
              this.items[index]["dropList2"] = dropList;
            }
          }
        }
    },
    async loaduserData(typeParentId) {
      await this.loadChildData(typeParentId)
      let typeId = typeParentId
      // 通过pk查询字典数据
      let res = await $utils.api.load(`/customer/customer/workType/type/${typeId}`)
      if (res && res.rows) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.userId;
          xx.name = element.nickName;
          xx.children = element.children || [];
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "maintainerId") {
            this.items[index]["dropList"] = dropList;
            // this.items[index]["dropList"] = (
            //   this.items[index]["dropList"] || []
            // ).concat(dropList);
          }
        }
      }

    },
  }
};
</script>

<style lang="less">
.workcolor {
  margin: 5px 5px 5px 150px;
  width: 80px;
  height: 30px;
}

.knowledge {
  margin: 5px 5px 5px 150px;
  width: 125px;
  height: 30px;
  background-color: #1890ff;
  color: #f6f8f7;
  border: none;
}

.completecolor {
  width: 80px;
  height: 30px;
  margin: 5px 5px 5px 30px;
}
</style>
